import { Box, Skeleton, Tbody, Td, Tr } from '@chakra-ui/react';

interface SkeletonTableBodyProps {
  columnCount: number;
  rows?: number;
  columnWidths?: string[];
  useFullWidth?: boolean;
}

export const SkeletonTableBody = ({
  columnCount,
  rows = 5,
  columnWidths = [],
  useFullWidth = false,
}: SkeletonTableBodyProps) => {
  const defaultWidth = '80px';

  return (
    <Tbody>
      {[...Array(rows)].map((_, rowIndex) => (
        <Tr key={rowIndex}>
          {[...Array(columnCount)].map((_, colIndex) => (
            <Td key={colIndex}>
              {useFullWidth ? (
                <Skeleton height="4" borderRadius="4px" />
              ) : (
                <Box
                  bg="gray.200"
                  height="4"
                  width={columnWidths[colIndex] || defaultWidth}
                  borderRadius="4px"
                />
              )}
            </Td>
          ))}
        </Tr>
      ))}
    </Tbody>
  );
};

// Usage Example:
// <Table>
//   <Thead>
//     <Tr>
//       <Th>Name</Th>
//       <Th>Age</Th>
//       <Th>City</Th>
//     </Tr>
//   </Thead>
//   {isLoading ? (
//     <SkeletonTableBody
//       columnCount={3}
//       columnWidths={['100px', '40px', '60px']}
//     />
//   ) : (
//     <Tbody>
//       {/* your real data */}
//     </Tbody>
//   )}
// </Table>
